import { Link } from "react-router-dom"

const Introduction = () => {
  return (
    <section className="min-h-[80vh] md:min-h-screen flex items-center justify-center py-8">
      <div className="flex flex-col items-center justify-center text-center gap-2">
        <img id="logo" src="/images/Logo1.png" alt="Logo" className="max-h-[50px] md:max-h-[75px]" />
        <h2 className="relative text-[28px] md:text-[46px] font-semibold leading-[100%] text-black text-center md:max-w-[60%] mb-[-0.17em] after:content-[''] after:absolute after:left-1/2 after:transform after:-translate-x-1/2 after:bottom-0 after:w-[100px] after:h-[3px] after:bg-[#bc9e59] pb-3">
          A Forest Escape with a Touch of Luxury
        </h2>
        <p className="text-center max-w-[40em] text-[14px] md:text-[18px] font-light mb-[0.5em] text-[#757575] mt-5">
          Reconnect with your spouse, retreat with friends, or rediscover yourself—just 2 hours from NYC. Nestled on 60 private acres, your stay includes a modern 256&nbsp;sq&nbsp;ft luxury suite surrounded by forest. Invigorate in the cold plunge, meditate by the stream, and reflect beside the fire pit. Enjoy outdoor grilling or cook in your private mini chef’s kitchen. Walk wooded trails and realign through nature and stillness.
        </p>

        <Link to="/booking?event=leafwell-nature-stay">
          <button className="bg-black text-white rounded-full px-16 py-4 mt-4 shadow hover:bg-gray-800 transition duration-300 w-full md:w-auto">
            BOOK NOW
          </button>
        </Link>
      </div>
    </section>
  )
}

export default Introduction
